import { Checkbox } from 'src/components/ui/checkbox';
import { useState } from 'react';

export const SelectAllCheckboxKnowledgeBasePage = ({
  onChange = () => {},
}: {
  onChange?: (checked: boolean) => void;
}) => {
  const [checked, setChecked] = useState(false);

  return (
    <>
      <Checkbox
        className={'w-5 h-5'}
        onDoubleClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        checked={checked}
        onCheckedChange={(checkedValue) => {
          setChecked(checkedValue === true);
          onChange(checkedValue === true);
        }}
      />
      {checked ? <span>Deselect all</span> : <span>Select all</span>}
    </>
  );
};
